import { render, staticRenderFns } from "./ModalDriverPassword.vue?vue&type=template&id=6d18b94e"
import script from "./ModalDriverPassword.vue?vue&type=script&lang=ts"
export * from "./ModalDriverPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports